import { mapGetters } from 'vuex'
import pluralize from 'pluralize'

export default {
  data() {
    const baseUrl = [
      this.entityType === 'search' ? 'search' : pluralize(this.entityType),
      this.$route.params.id
    ]
      .filter((item) => !!item)
      .join('/')
    return {
      categorySlugUrl: [
        this.$route.params.topCategory,
        this.$route.params.category,
        this.$route.params.subCategory
      ]
        .filter((cat) => !!cat)
        .join('/'),
      baseUrl
    }
  },

  computed: {
    ...mapGetters({
      categoryFilters: 'listingPageFilters/categoryFilters',
      categories: 'category/categories'
    })
  },

  methods: {
    categoryTree(
      categories,
      isActiveSlugUrl = '',
      filterFn,
      isFilterModal = false
    ) {
      const nodes = categories.filter(filterFn)
      // here is to reduce the number of otherNodes that goes in each level
      // lodash without is not working in mixin
      const nodeIds = nodes.map((node) => node.id)
      const otherNodes = categories.reduce((prev, curr) => {
        if (nodeIds.includes(curr.id)) {
          return prev
        }
        return [...prev, curr]
      }, [])

      nodes.forEach((node) => {
        node.isActive = node.slugUrl === isActiveSlugUrl
        node.linkUrl = `/${this.baseUrl}/${node.slugUrl}`
        if (node.isActive) {
          this.activeCategory = node || this._defaultActiveCategory()
        }
        // This is needed as in recursive, the 'this' context is lost
        // eslint-disable-next-line no-useless-call
        node.children = this.categoryTree.call(
          this,
          otherNodes,
          isActiveSlugUrl,
          this._filterByParentId(node.id),
          isFilterModal
        )

        if (node.children.length) {
          node.isSelectable = false

          // Add Select All X option for mobile filter modal
          if (
            (!node.isActive || this.entityType !== 'category') &&
            isFilterModal === true
          ) {
            node.children.unshift(
              Object.assign({}, node, {
                isSelectable: true,
                isSelectAll: true,
                children: [] // To prevent memory leak
              })
            )
          }
        } else {
          node.isSelectable = true
        }
      })

      return nodes
    },

    navigateToCategory(slugUrl) {
      const params = {}
      const pathName = `${this.entityType}-listing-page`
      const query = { ...this.$route.query }
      const keysToRemain = [
        'view',
        'sort',
        'brands',
        'min-price',
        'max-price',
        'others',
        'q'
      ]
      const keysToBeRemoved = []

      slugUrl.split('/').forEach((slug, ind) => {
        if (ind === 0) {
          params.topCategory = slug
        } else if (ind === 1) {
          params.category = slug
        } else if (ind === 2) {
          params.subCategory = slug
        }
      })

      Object.keys(query).forEach((key) => {
        if (!keysToRemain.includes(key)) {
          keysToBeRemoved.push(key)
        }
      })

      keysToBeRemoved.forEach((key) => {
        delete query[key]
      })

      this.$router.push({ name: pathName, params, query })
    },

    unsetCategoryParams() {
      const params = { ...this.$route.params }

      params.topCategory = undefined
      params.category = undefined
      params.subCategory = undefined

      return params
    },

    _filterBySlugUrl(slugUrl) {
      return (category) => category.slugUrl === slugUrl
    },

    _startsWithSlugUrl(slugUrl) {
      return (category) =>
        category.slugUrl !== slugUrl && category.slugUrl.startsWith(slugUrl)
    },

    _filterByParentId(parentId) {
      // This is disabled because one can be number & the other string
      // eslint-disable-next-line eqeqeq
      return (category) => category.parentId == parentId
    },

    _defaultActiveCategory() {
      return {
        children: [],
        id: '',
        isActive: false,
        label: '',
        parentId: '',
        slugUrl: ''
      }
    },

    _transformCategories(categories) {
      // Filters for categories related to top-lvl category
      // e.g. Tree in Makeup page should show all categories with 'makeup' at start of its slug
      const filteredCategories = categories.filter(
        (category) =>
          category.link.split('/')[0] === this.$route.params.topCategory
      )

      // remapped to be used by tree component
      return filteredCategories.map((category) => ({
        id: category.id,
        label: category.text,
        slugUrl: category.link,
        parentId: category.parentId
      }))
    }
  }
}
